import { useEffect } from 'react';

const SCROLL_REGION_SELECTOR = '[data-app-scroll-region]';

type SavedRegion = {
  el: HTMLElement;
  scrollTop: number;
  prevOverflow: string;
};

let lockCount = 0;
let savedRegions: SavedRegion[] = [];
let prevBodyOverflow = '';

/**
 * Prevents background scroll while overlays/modals are open.
 * Locks the app main scroll regions (Layout outlet) and body.
 * Ref-counted so nested modals do not leave scroll stuck after close.
 */
export function useScrollLock(locked: boolean) {
  useEffect(() => {
    if (!locked) return;

    if (lockCount === 0) {
      const regions = Array.from(
        document.querySelectorAll<HTMLElement>(SCROLL_REGION_SELECTOR),
      );
      savedRegions = regions.map((el) => ({
        el,
        scrollTop: el.scrollTop,
        prevOverflow: el.style.overflow,
      }));
      prevBodyOverflow = document.body.style.overflow;

      regions.forEach((el) => {
        el.style.overflow = 'hidden';
      });
      document.body.style.overflow = 'hidden';
    }

    lockCount += 1;

    return () => {
      lockCount = Math.max(0, lockCount - 1);
      if (lockCount > 0) return;

      savedRegions.forEach(({ el, scrollTop, prevOverflow }) => {
        el.style.overflow = prevOverflow;
        el.scrollTop = scrollTop;
      });
      document.body.style.overflow = prevBodyOverflow;
      savedRegions = [];
      prevBodyOverflow = '';
    };
  }, [locked]);
}
